import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

// Geliştirme panosu (GitHub) — salt-okunur, development.read
// (server: development-base.routes.js).
// Contract: BayinerIOT-Workspace-/docs/api-contracts/development-board.md
//
// "Yenile": refresh mutation'ı server önbelleğini yeniden doldurur, ardından
// tag invalidation ile query aynı taze veriyi okur.
const developmentApi = createApi({
  reducerPath: "development",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["DevelopmentBoard", "DevelopmentPulls"],
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      getDevelopmentBoard: builder.query({
        query: (data) =>
          apiFunction(data, `/api/development/storageRoles/getBoard`, "POST"),
        providesTags: ["DevelopmentBoard"],
      }),
      getDevelopmentPullRequests: builder.query({
        query: (data) =>
          apiFunction(data, `/api/development/storageRoles/getPullRequests`, "POST"),
        providesTags: ["DevelopmentPulls"],
      }),
      refreshDevelopmentBoard: builder.mutation({
        query: ({ token }) =>
          apiFunction({ token, refresh: true }, `/api/development/storageRoles/getBoard`, "POST"),
        invalidatesTags: ["DevelopmentBoard"],
      }),
      refreshDevelopmentPullRequests: builder.mutation({
        query: ({ token }) =>
          apiFunction({ token, refresh: true }, `/api/development/storageRoles/getPullRequests`, "POST"),
        invalidatesTags: ["DevelopmentPulls"],
      }),
    };
  },
});

export const {
  useGetDevelopmentBoardQuery,
  useGetDevelopmentPullRequestsQuery,
  useRefreshDevelopmentBoardMutation,
  useRefreshDevelopmentPullRequestsMutation,
} = developmentApi;
export { developmentApi };
